import Subject from "../cse4sub/Subject";
import React from 'react'
import csm from '../assets/AE401mid21.pdf'

export default function Sm() {
  return (
    <div>
       <Subject title="Strength of Materials(AE401)" book1=" " book2=" "mid="Q. Paper"
    book1Link="#" book2Link="#" int21="#" mid21={csm} end21="#"
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}